import { Button } from '@xprog/prensa'
import React from 'react'

export const LoginButton: React.FC<any> = props => {
  return (
    <Button
      {...props}
      variant='outlined'
      css={{
        button: {
          borderRadius: '$rounded',
          height: '40px',
          paddingLeft: '$9',
          paddingRight: '$9'
        },
        label: {
          color: '$basicBlack',
          fontFamily: '$primary',
          fontSize: '14px',
          fontWeight: '600',
          textTransform: 'uppercase'
        }
      }}
    >
      Entrar
    </Button>
  )
}